"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TABS = exports.MESSAGE_LABELS = void 0;
var MESSAGE_LABELS = {
  MARK_AS_READ: "Mark as Read",
  MARK_AS_UNREAD: "Mark as Unread",
  ARCHIVE_MESSAGE: "Archive"
};
exports.MESSAGE_LABELS = MESSAGE_LABELS;
var DEFAULT_TABS = [{
  id: "unread",
  label: "Unread",
  filters: {
    isRead: false
  }
}, {
  id: "all",
  label: "All Messages",
  filters: {}
}];
exports.DEFAULT_TABS = DEFAULT_TABS;